module.exports = __webpack_public_path__ + "static/img/recharge_active.c1bd1677.png";